import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConsumptionGraphComponent } from "../consumption-graph/consumption-graph.component";

@Component({
    selector: 'consumption-dashboard-component',
    templateUrl: './consumption-dashboard.component.html',
    styleUrls: ['./consumption-dashboard.component.scss'],
    standalone: true,
    imports: [ButtonModule, CardModule, ConsumptionGraphComponent],
    providers: [],
})
export class ConsumptionDashboardComponent {
    @Input() activeTab!: string;
    @Output() activeTabChange = new EventEmitter<string>();
}